import { Outlet, NavLink } from 'react-router-dom';
import { useIsOperator } from './admin/hooks/useIsOperator';

export default function JobApplyLayout() {
  const { isOperator } = useIsOperator();

  return (
    <div className="min-h-screen bg-base-200">
      <header className="navbar bg-base-100 shadow-sm px-6">
        <div className="flex-1">
          <a href="/job-apply" className="text-xl font-bold text-primary">
            TBIT{' '}
            <span className="font-normal text-base-content/60">Job Apply</span>
          </a>
        </div>
        <nav className="flex-none">
          <ul className="menu menu-horizontal gap-1">
            <li><NavLink to="/job-apply/dashboard">Panel</NavLink></li>
            <li><NavLink to="/job-apply/cv">Hoja de vida</NavLink></li>
            <li><NavLink to="/job-apply/preferences">Preferencias</NavLink></li>
            <li><NavLink to="/job-apply/history">Historial</NavLink></li>
            {isOperator && (
              <>
                <li><span className="opacity-30 px-2">|</span></li>
                <li><NavLink to="/job-apply/admin/overview" className="text-secondary">Resumen</NavLink></li>
                <li><NavLink to="/job-apply/admin/users" className="text-secondary">Usuarios</NavLink></li>
                <li><NavLink to="/job-apply/admin/jobs" className="text-secondary">Ofertas</NavLink></li>
                <li><NavLink to="/job-apply/admin/workers" className="text-secondary">Workers</NavLink></li>
              </>
            )}
          </ul>
        </nav>
      </header>
      <main className="container mx-auto px-4 py-8 max-w-6xl">
        <Outlet />
      </main>
    </div>
  );
}
